<template>
    <div id="create_core_waybill_alert">
        <div v-if="is_initialized"
            class="ui segment z-depth-2"
            :style="{
                background: theme.background,
                color: theme.color.font
            }">
            <h3>
                <!-- 是否要建立 -->
                {{ $t('ui.scanner.alerts.is_created') }}
                <span>
                    {{ current_store.current_core_waybill.number }}
                </span>
                <span
                    style="font-size: small;"
                    v-if="current_store.current_core_waybill.material">
                    <span class="title_number">
                        [{{ current_store.current_core_waybill.material.name }}]
                    </span>
                </span>
            </h3>

            <div class="ui message error" v-if="create_core_waybill_error">
                {{ create_core_waybill_error }}
            </div>

            <div class="right aligned"
                style="padding-top: 12px;">
                <button class="ui inverted red button"
                    @click="give_up_create_core_waybill()">
                    <!-- 放棄 -->
                    {{ $t('ui.scanner.alerts.give_up') }}
                </button>
                <button class="ui inverted blue button"
                    @click="define_create_core_waybill()">
                    <!-- 確定 -->
                    {{ $t('ui.scanner.alerts.definite') }}
                </button>
            </div>
        </div>

    </div>
</template>

<script>
import Keyboard from '@javascripts/keyboard.js'

export default {
    components: {
    },
    props: {
        is_inverted: {
            default: false,
            type: Boolean
        },
        is_modal_opened: {
            default: false,
            type: Boolean
        },
        is_displayed: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            is_initialized: false,
            create_core_waybill_error: "",
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.scanner_module
        },
        theme() {
            return this.current_store.config.theme
        },
        current_core_waybill() {
            return this.current_store.current_core_waybill
        },
    },
    watch: {
        is_displayed(new_val, old_val) {
            if (new_val != old_val) {
                if (new_val) {
                    this.create_core_waybill_error = ""
                    this.toggle_scanner_is_keydown(false)
                } else {
                    this.toggle_scanner_is_keydown(true)
                }
            }
        }
    },
    deleted() {
    },
    mounted() {
        $(window).bind("keydown", this.window_keydown)
        this.init()
    },
    methods: {
        window_keydown(e) {
            if (this.is_displayed) {
                var keyboard = new Keyboard(e)

                if (keyboard.key_code == 13 && !this.current_store.is_keydown) {
                    this.define_create_core_waybill()
                }
            }
        },
        async init() {
            try {
                await new Promise(resolve => {
                    this.is_initialized = true
                    resolve()
                })
            } catch (e) {
                console.log(e)
            }
        },
        toggle_scanner_is_keydown(boolean = false) {
            this.current_store.is_keydown = boolean
        },
        give_up_create_core_waybill() {
            this.toggle_scanner_is_keydown(true)
            this.$parent.alert_failure()
            this.$noty.warning("未建立運單", 1200)
        },
        async define_create_core_waybill() {
            await this.create_core_waybill()
            if (this.create_core_waybill_error == "") {
                await this.$parent.alert_success()
                await this.toggle_scanner_is_keydown(true)
            }
        },
        create_core_waybill() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_core_waybills_create).parse(
                {}
            )
            this.current_core_waybill['is_used'] = true
            this.current_core_waybill['material_identity'] = this.current_core_waybill.material.identity
            this.current_core_waybill['partition_identity'] = this.current_core_waybill.partition.identity

            return axios.post(url, this.current_core_waybill, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        // this.$noty.success('建立運單成功')
                        this.$noty.success(
                            this.$t('ui.notifications.success.create__name', {
                                name: this.$t('models.core_waybills')
                            })
                        )
                    } else {
                        // this.$noty.error('建立運單 失敗')
                        this.$noty.error(
                            this.$t('ui.notifications.error.create__name', {
                                name: this.$t('models.core_waybills')
                            })
                        )
                        this.create_core_waybill_error = response.data.errors
                        return Promise.reject(response.data.errors)
                    }
                })
        },
    },

}
</script>

<style lang="scss" scoped>
    .center.aligned {
        text-align: center;
    }
    .left.aligned {
        text-align: left;
    }
    .right.aligned {
        text-align: right;
    }
    #create_core_waybill_alert {
        & {
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            z-index: 2;
            background-color: rgba(27, 28, 29, 0.8);
        }
        .segment {
            width: 50%;
            top: 20%;
            margin: 0 auto;
        }
    }
    @media only screen and (max-width: 767px) {
        #create_core_waybill_alert {
            .segment {
                width: 100%;
            }
        }
    }
</style>
